import React from 'react';
import { ReverseRotate } from '../reverse-rotate';
import { BaseLabel } from '../base-label';
import { GenericIcon } from '../icon/generic-icon';
import { COLORS, LABEL_FONT_SIZE } from '../..';
import { useLabelWithIcon } from './use-label-with-icon';
export const LabelWithIcon = (props) => {
    const { width, height, text, angle = 0, color = COLORS.TEXT, icon, fontSize = LABEL_FONT_SIZE } = props.definition;
    const labelSize = fontSize * 2;
    const { midX, midY, iconX, iconY, labelY } = useLabelWithIcon(props);
    return (React.createElement("svg", { width: width, height: height },
        React.createElement(ReverseRotate, { rotateX: midX, rotateY: midY, angle: angle },
            text ? (React.createElement(BaseLabel, { color: color, y: labelY, fontSize: fontSize }, text)) : null,
            icon ? React.createElement(GenericIcon, { x: iconX, y: iconY, type: icon, size: labelSize, fill: color }) : null)));
};
//# sourceMappingURL=label-with-icon.js.map